export default "__VITE_ASSET__DFYNJ$Od__"